export const options = {
  init: {
    distributed_tracing: { enabled: true },
    privacy: { cookies_enabled: true },
    ajax: { deny_list: ['bam.nr-data.net'] }
  }, // NREUM.init
  info: {
    beacon: 'bam.nr-data.net',
    errorBeacon: 'bam.nr-data.net',
    licenseKey: process.env.NEXT_PUBLIC_NEWRELIC_OPTIONS_INFO_LICENCE_KEY,
    applicationID: process.env.NEXT_PUBLIC_NEWRELIC_OPTIONS_INFO_APPLICATION_ID,
    sa: 1
  }, // NREUM.info
  loader_config: {
    accountID: process.env.NEXT_PUBLIC_NEWRELIC_OPTIONS_INFO_ACCOUNT_ID,
    trustKey: process.env.NEXT_PUBLIC_NEWRELIC_OPTIONS_INFO_TRUST_KEY,
    agentID: process.env.NEXT_PUBLIC_NEWRELIC_OPTIONS_INFO_AGENT_ID,
    licenseKey: process.env.NEXT_PUBLIC_NEWRELIC_OPTIONS_INFO_LICENCE_KEY,
    applicationID: process.env.NEXT_PUBLIC_NEWRELIC_OPTIONS_INFO_APPLICATION_ID
  } // NREUM.loader_config
};
